<template>
<div class="chapter">
<div class="inner_page">
<p><span class="com-rorohiko-pagestaker-style"><a id="_idTextAnchor006"></a><a id="_idTextAnchor007"></a><a id="_idTextAnchor008"></a><a id="_idTextAnchor009"></a><a id="_idTextAnchor010"></a><a id="_idTextAnchor011"></a><a id="_idTextAnchor012"></a><a id="_idTextAnchor013"></a></span><span epub:type="pagebreak" id="pagev" title="v"></span></p>
<p class="firstcenter">These essays are dedicated to the students, faculty, and institutions who heard much of this material over the past fifteen years. I am grateful for the opportunities I have had to learn from all of you, and to know of the great work these schools continue to do in building up the Asian church.</p>
<p class="firstcenter">Trinity Theological College, Republic of Singapore</p>
<p class="firstcenter">TCA College, Republic of Singapore</p>
<p class="firstcenter">Sabah Theological Seminary, Kota Kinabalu, Sabah, Malaysia</p>
<p class="firstcenter">Presbyterian University and Theological Seminary, Seoul, South Korea</p>
<p class="firstcenter">Yonsei University, Seoul, South Korea</p>
<p class="firstcenter">McGilvery Faculty of Theology at Payap University, Chiang Mai, Thailand</p>
<p class="firstcenter">Nanjing Union Theological Seminary, Nanjing, China</p>
<p class="firstcenter">Shandong Theological Seminary, Jinan, China</p>
<p class="firstcenter">Colombo Theological Seminary, Colombo, Sri Lanka</p>
<p class="firstcenter">Myanmar Institute of Theology, Insein, Yangon, Myanmar </p>
<p class="firstleft"><span epub:type="pagebreak" id="pagevi" title="vi"></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03dedication.vue?3dcc0f9a